'use client';

import { Metadata } from 'next';
import Script from 'next/script';
import { useEffect, useTransition } from 'react';

import { useTranslation } from '@/i18n/client';
import { ServerError } from '@/modules/error/components/serverError';
import { dataLayer } from '@/modules/google/data-layer/lib/data-layer';

export const metadata: Metadata = {
  robots: {
    follow: false,
    index: false,
  },
};

export default function Error() {
  const [t] = useTranslation('common');

  useEffect(() => {
    document.title = `${t('common.500.title')} | ${t('meta.title')}`;
    dataLayer({
      event: 'error_page_view',
      error_code: '500',
      page_type: 'error',
    });
  }, []);

  return (
    <>
      <ServerError />
    </>
  );
}

export const dynamic = 'force-dynamic';
export const revalidate = 0;
